import { classed } from "@/lib/classed";

/**
 * Surface — visual container with background, border, rounding, and padding.
 * Use for cards, panels, bordered sections.
 *
 * Layout concerns (position, overflow) stay in className — they're not visual identity.
 * Supports `as` prop: `<Surface as="section">` renders a `<section>`.
 */
export const Surface = classed("div", {
  base: "",
  variants: {
    bg: {
      none: "",
      surface: "bg-[color:var(--surface)]",
      container: "bg-[color:var(--surface-container)]",
      high: "bg-[color:var(--surface-container-high)]",
      background: "bg-[color:var(--background)]",
      dim: "bg-[color:var(--surface-container-high)]",
      "error-container": "bg-[color:var(--error-container)]",
      primary: "bg-[color:var(--primary)]",
      "primary-container": "bg-[color:var(--primary-container)]",
      "container-low": "bg-[color:var(--surface-container-low)]",
      scrim: "bg-[color:var(--scrim)]",
      "success-container": "bg-[color:var(--accent-green-bg)]",
    },
    border: {
      none: "",
      default: "border border-[color:var(--outline-variant)]",
      top: "border-t border-t-[color:var(--outline-variant)]",
      bottom: "border-b border-b-[color:var(--outline-variant)]",
      dashed: "border border-dashed border-[color:var(--outline-variant)]",
    },
    rounded: {
      none: "",
      md: "rounded-md",
      lg: "rounded-lg",
      xl: "rounded-xl",
      "2xl": "rounded-2xl",
      full: "rounded-full",
    },
    padding: {
      none: "",
      xs: "p-1",
      sm: "p-2",
      md: "p-3",
      lg: "p-4",
      xl: "p-6",
    },
    elevation: {
      none: "",
      sm: "shadow-sm",
      md: "shadow-md",
      lg: "shadow-lg",
      xl: "shadow-xl",
    },
  },
  defaultVariants: {
    bg: "none",
    border: "none",
    rounded: "none",
    padding: "none",
    elevation: "none",
  },
  compoundVariants: [
    { border: "default", rounded: "none", className: "rounded-lg" },
  ],
});
